import { Loader } from '@mantine/core'
import { Navigate } from 'react-router-dom'

import { usePageAccess } from '@/hooks/constant/usePageAccess'
import { EmmaPath } from '@/router/paths'

import { canView } from './authorizations'
import { useAuth } from './use-auth'

interface PageGuardProps {
  path: EmmaPath
  children: React.ReactNode
}

/**
 * Blocks direct navigation to a page the user's roles cannot view (code
 * default or Settings → Pages override). Before this, only the sidebar
 * honoured the role lists and any logged-in user could open any URL.
 */
export const PageGuard = ({ path, children }: PageGuardProps) => {
  const { userRoles, isLoading } = useAuth()
  const { overrides, isSettled } = usePageAccess()

  if (isLoading || !isSettled) return <Loader />
  if (!canView(userRoles, path, overrides)) return <Navigate replace to={EmmaPath.EMMA} />
  return <>{children}</>
}
